import { createSelector } from 'reselect';
import { rootSelector } from '../selectors';

export const getDataExportFrequencyMinutes = createSelector(
  rootSelector,
  settings => settings.dataExport.freqMinutes || 0,
);
